export default "__VITE_ASSET__CQxDImj6__"